module.exports = __webpack_public_path__ + "static/img/5.65b3744.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productcenter/zncy/zncq/5.png
// module id = FgQl
// module chunks = 1